import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { clearMyTime, btnHint_Click, btnOrder_Click, pailie, gameinit } from './game';

import showimg1 from '../../../assets/images/llk/1.png'
import showimg2 from '../../../assets/images/llk/2.png'
import './index.scss'

export default function LLKGame() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate()
    const type = searchParams.get('type'); // 获取 type 的值（如 "1"）
    useEffect(() => {
        const img = new Image();
        if (type === '1') {

            img.src = showimg1;
        }
        if (type === '2') {
            img.src = showimg2;
        }
        img.onload = () => {
            gameinit(img, type)

        };
        img.onerror = () => {
            console.error('图片加载失败:', img.src);
            // 可以在这里设置一个备用图片或显示错误信息
        };
        return () => {
            clearMyTime()
        }
    }, [type])
    return (
        <div className="gamebody">

            <div className="box">
                <div className="timebox">
                    <div className="jindu">
                        <div className="percent"></div>
                    </div>
                </div>
                <div className="text">
                    2:30
                </div>
            </div>

            <canvas id="canvas">
                <span>你的浏览器不支持Html5，请用Chrome、Opera、Firefox、Safari或IE9
                </span>
            </canvas>
            <div className="bottom">
                <div className="btn back" onClick={() => {
                    navigate('/LLK/Choose')
                }}>
                    <i></i>
                    <p className="txt" >
                        返回
                    </p>
                </div>
                <div className="btn help" onClick={() => { btnHint_Click() }} >
                    <i></i>
                    <p className="txt">
                        求助
                    </p>
                </div>
                <div className="btn rearrange" onClick={() => { pailie() }}>
                    <i></i>
                    <p className="txt">
                        重新排列
                    </p>
                </div>
                <div className="btn  startorstop stop" onClick={() => { btnOrder_Click() }}>
                    <i></i>
                    <p className="txt">
                        暂停游戏
                    </p>
                </div>
            </div>
            <div className="failedbox">
                <div className="close" onClick={() => {
                    navigate('/LLK/Choose')
                }}>
                </div>
            </div>
            <div className="successbox">
                <div className="close" onClick={() => {
                    navigate('/LLK/Choose')
                }}>
                </div>
            </div>
        </div >
    )
}
